import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 查询商家审核列表
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/getProductAuditList`, params),
    //审核状态
    pass: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/product/updateProductAudit`, params),
    //待审核信息
    wwc: params => request.get(`${base.baseUrl}/yyyhao-cloud-product/product/getProductAuditCount`, params),

}